import { render } from "./JobTypeForm.vue?vue&type=template&id=a248705c"
import script from "./JobTypeForm.vue?vue&type=script&lang=ts"
export * from "./JobTypeForm.vue?vue&type=script&lang=ts"
script.render = render

export default script